import { render, staticRenderFns } from "./CustomCombobox.vue?vue&type=template&id=c2b9ef54"
import script from "./CustomCombobox.vue?vue&type=script&lang=js"
export * from "./CustomCombobox.vue?vue&type=script&lang=js"
import style0 from "./CustomCombobox.vue?vue&type=style&index=0&id=c2b9ef54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports